module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADPSURBVHgB7ZThDcIgEIWPxgHYQEbREbqBGziCruAE6gQ6Am7QDXQD2QAfCEmDLVd+aEzDSwiP8l2vSe+OqKpAon+w1l6wmQyvhBDriawE2348ReA1E+TuT1gq+CPHRt8kd0/6ghr6gWqS/0uySM6SKc0lav8RvOLYaER6E/tgSL0ERWza8Sv3hTSuDsFdKTs0Vg6ZwB1Wi2ADVsPvM+w2jpX0nxhc6LEovHiDTdJ7Zt0nsF61T2oSL8XwsbKi51ivtITPzKjQrkeCv3EszU4vbA5ZnSPs0MQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/oneactive.png
// module id = lATD
// module chunks = 1